import React from 'react';

import { Tabs } from 'antd';

import { SettingsCompanyInfo } from 'components/Settings/SettingsCompanyInfo';
import { SettingsConfig } from 'components/Settings/SettingsConfig';
import { SettingsFinanceInfo } from 'components/Settings/SettingsFinanceInfo';
import { AccountContextProvider } from 'lib/providers/AccountContextProvider';


export function SettingsAccount() {
    const items = [
        {
            key: 'company_data',
            label: 'Dados da empresa',
            children: (
                <AccountContextProvider>
                    {() => <SettingsCompanyInfo />}
                </AccountContextProvider>
            ),
        },
        {
            key: 'financial',
            label: 'Financeiro',
            children: (
                <AccountContextProvider>
                    {() => <SettingsFinanceInfo />}
                </AccountContextProvider>
            ),
        },
        {
            key: 'config',
            label: 'Preferências',
            children: (
                <AccountContextProvider>
                    {() => <SettingsConfig />}
                </AccountContextProvider>
            ),
        },
    ];

    return (
        <Tabs defaultActiveKey="company_data" items={items} />
    );
}
